import request from '@/utils/request'

// 查询优惠券模板列表
export function fetchList (data) {
  return request.post('/pc/couponTemplate/page', data, {
    trim: true
  })
}

// 创建优惠券模板
export function create (data) {
  return request.post('/pc/couponTemplate/create', data)
}

// 修改优惠券模板
export function updateById (data) {
  return request.post('/pc/couponTemplate/updateById', data)
}

// 删除优惠券模板
export function deleteById (id) {
  return request.get(`/pc/couponTemplate/delete/${id}`)
}

// 批量删除优惠券模板
export function deleteByIdInBatch (ids) {
  return request.get('/pc/couponTemplate/delete/batch', {
    params: {
      ids
    }
  })
}

// 优惠券模板详情
export function getDetail (id) {
  return request.get(`/pc/couponTemplate/detail/${id}`)
}

// 优惠券模板使用场景
export function getUseScene () {
  return request.get('/pc/couponTemplate/scenes')
}

// 优惠券模板延期场景
export function getExtendScene () {
  return request.get('/pc/couponTemplate/extendScenes')
}
